import React, { useContext, useEffect, useState } from 'react';

import {
  Modal,
  Text,
  useResponsiveParams,
  GridItem,
  Grid,
  Button,
  useQuantaFormikContext,
  MixedGridGroup,
  QuantaToggle,
  Label,
  CountAnimation,
} from 'quanta-ui';
// import CurrencyFormater from '../../../../../lib/intl/CurrencyFormater';
import{ CurrencyFormater} from 'quanta-flows'

import {
  faExclamationTriangle,
  faInfoCircle,
  faSave,
  faSpinner,
  faTimesCircle,
  faCheck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { QuantaConfigContext } from '../../../../../lib/config/ConfigProvider';
import { QuantaConfigContext } from 'quanta-flows';
import { useLazyQuery } from '@apollo/client';
// import {
//   //  GET_PRODUCT_DETAILS,
//   //  GET_PLAN_COVER_DETAILS,
//   CALCULATE_PREMIUM_FOR_PROPOSAL,
// } from 'quanta-flows/modules/policy/renewal/health';
import 
{ 
   GET_PRODUCT_DETAILS,
   GET_PLAN_COVER_DETAILS,
   CALCULATE_PREMIUM_FOR_PROPOSAL,
  } from '../queries';

// import { Error, Loading } from '../../../../../lib/layout';
import { Error,Loading } from 'quanta-flows/modules/layout';
// import useFetchQuery from '../../../../../lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
// import { updateViewRenewPolicy } from '../_graphql/state';
import { updateViewRenewPolicy } from 'quanta-flows/modules/policy/renewal/health/state';
export default function ModalCoversPlans({
  showCoversPlans,
  setShowCoversPlans,
  planData,
  quoteData,
  forwardedRef,
  forwardedAlertsRef,
  forwardedRenewFormRef,
  date,
  productCode,
  productName,
  planName,
  planCode,
  renewalMode,
  viewRenewPolicy,
  proposalDetails,
  valuesBeforeEdit,
  productQuestionList,
}) {
  const fetchQuery = useFetchQuery();
  const { values, setFieldValue, errors, setValues, initialValues } =
    useQuantaFormikContext();
  const { branding } = useContext(QuantaConfigContext);
  const [plans, setPlans] = useState(
    planData?.plans ? planData?.plans : [],
  );
  const [isCalculatingPremium, setCalculatingPremium] =
    useState(false);
  const [errorPremium, setErrorPremium] = useState(null);
  const [warningPremium, setWarningPremium] = useState(null);
  const [initLoad, setInitLoad] = useState(false);
  const [isCancelled, setCancelled] = useState(false);

  const repeatFormsReadOnly = useResponsiveParams({
    for_mobile: 2,
    for_desktop: 3,
  });
  const repeatFormsonEdit = useResponsiveParams({
    for_mobile: 1,
    for_desktop: 3,
    for_iPad: 3,
  });

  const screen = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
    for_iPad: 'ipad',
  });

  const [
    getProductDetails,
    {
      loading: loadingProductDetails,
      error: errorProductDetails,
      data: dataProductDetails,
    },
  ] = useLazyQuery(GET_PRODUCT_DETAILS, {
    fetchPolicy: 'cache-first',
  });

  // console.log("get product detais",dataProductDetails);
  const getMedicalQuestionsMapped = (values,insured) => {
    let responseObj = {};
    responseObj = {
      relationship: insured,
      questions: Object.keys(values?.medicalUnderwriting[`${insured}`]).map(
        (k) => {
          let answerText = '';
          const question = productQuestionList.find(
            (question) => question.srNo === k,
          );
          if (question) {
            if (!question.isParent) {
              const parentQuestion = productQuestionList.find((q) =>
                q.childQuesNo.find(
                  (c) =>
                    c.toLowerCase() === question.srNo.toLowerCase(),
                ),
              );
              if (
                parentQuestion &&
                ((values?.medicalUnderwriting[`${insured}`][
                  `${parentQuestion.srNo}`
                ].checkboxAnswer === 'Yes' &&
                  !parentQuestion.condToChild) ||
                  (values?.medicalUnderwriting[`${insured}`][
                    `${parentQuestion.srNo}`
                  ].checkboxAnswer === 'No' &&
                    parentQuestion.condToChild))
              ) {
                answerText = '';
              } else {
                answerText =
                  question.isChkTxtReq &&
                  values?.medicalUnderwriting[`${insured}`][k] === 'Yes'
                    ? values?.medicalUnderwriting[`${insured}`][k].textareaAnswer
                    : question.isChkTxtReq &&
                      values?.medicalUnderwriting[`${insured}`][k]
                        .checkboxAnswer === 'No'
                    ? values?.medicalUnderwriting[`${insured}`][k]
                        .checkboxAnswer
                    : question.isChkReq
                    ? values?.medicalUnderwriting[`${insured}`][k]
                        .checkboxAnswer
                    : values?.medicalUnderwriting[`${insured}`][k]
                        .textareaAnswer;
              }
            } else {
              answerText =
                question.isChkTxtReq &&
                values?.medicalUnderwriting[`${insured}`][k]
                  .checkboxAnswer === 'Yes'
                  ? values?.medicalUnderwriting[`${insured}`][k]
                      .textareaAnswer
                  : question.isChkTxtReq &&
                    values?.medicalUnderwriting[`${insured}`][k]
                      .checkboxAnswer === 'No'
                  ? values?.medicalUnderwriting[`${insured}`][k]
                      .checkboxAnswer
                  : question.isChkReq
                  ? values?.medicalUnderwriting[`${insured}`][k]
                      .checkboxAnswer
                  : values?.medicalUnderwriting[`${insured}`][k]
                      .textareaAnswer;
            }
          } else {
            answerText = values?.medicalUnderwriting[`${insured}`][k].checkboxAnswer;
          }
          return {
            srNo: k,
            answer: {
              checkboxAnswer:
                values?.medicalUnderwriting[`${insured}`][k].checkboxAnswer,
              answerText,
              textareaAnswer:
                values?.medicalUnderwriting[`${insured}`][k].textareaAnswer,
            },
          };
        },
      ),
    };
    return responseObj;
  };

  const getInsuredDetailsObj = (
    val,
    packIdx,
    addOnCoverIdx,
    covers,
  ) => {
    let insuredDetailsArr = [];
    Object.keys(proposalDetails?.insuredDetails)
      .filter(
        (member) =>
          !proposalDetails?.insuredDetails[member]?.isMemberDeleted &&
          !proposalDetails?.insuredDetails[member]?.isSoftAdded &&
          !proposalDetails?.insuredDetails[member]?.isHardDeleted,
      )
      .forEach((member) => {
        let insuredDetailsObj = {};
        insuredDetailsObj.relationship = member;
        insuredDetailsObj.gender =
          proposalDetails?.insuredDetails[member]?.gender;
        insuredDetailsObj.title =
          proposalDetails?.insuredDetails[member]?.title;
        insuredDetailsObj.dob =
          proposalDetails?.insuredDetails[member]?.dob;
        insuredDetailsObj.age =
          proposalDetails?.insuredDetails[member]?.age;
        insuredDetailsObj.firstName =
          proposalDetails?.insuredDetails[member]?.firstName;
        insuredDetailsObj.middleName =
          proposalDetails?.insuredDetails[member]?.middleName;
        insuredDetailsObj.lastName =
          proposalDetails?.insuredDetails[member]?.lastName;
        insuredDetailsObj.maritalStatus =
          proposalDetails?.insuredDetails[member]?.maritalStatus;
        insuredDetailsObj.occupation =
          proposalDetails?.insuredDetails[member]?.occupation;
        insuredDetailsObj.otherOccupation =
          proposalDetails?.insuredDetails[member]?.otherOccupation;
        insuredDetailsObj.maritalStatus =
          proposalDetails?.insuredDetails[member]?.maritalStatus;
        insuredDetailsObj.height =
          proposalDetails?.insuredDetails[member]?.height;
        insuredDetailsObj.weight =
          proposalDetails?.insuredDetails[member]?.weight;
        insuredDetailsObj.pedWaitingPeriod =
          proposalDetails?.insuredDetails[member]?.pedWaitingPeriod;
        insuredDetailsObj.nomineeDetails = proposalDetails
          ?.nomineeDetails[member]
          ? {
              name: proposalDetails?.nomineeDetails[member]
                ?.isSoftAdded
                ? ''
                : proposalDetails?.nomineeDetails[member]?.name,
              dob: proposalDetails?.nomineeDetails[member]
                ?.isSoftAdded
                ? ''
                : proposalDetails?.nomineeDetails[member]?.dob,
              relationshipWithInsured: proposalDetails
                ?.nomineeDetails[member]?.isSoftAdded
                ? ''
                : proposalDetails?.nomineeDetails[member]
                    ?.relationshipWithInsured,
              insuredRelationship: member,
              nameOfAppointee: proposalDetails?.nomineeDetails[member]
                ?.isSoftAdded
                ? ''
                : proposalDetails?.nomineeDetails[member]
                    ?.nameOfAppointee,
              relationshipWithAppointee: proposalDetails
                ?.nomineeDetails[member]?.isSoftAdded
                ? ''
                : proposalDetails?.nomineeDetails[member]
                    ?.relationshipWithAppointee,
            }
          : null;
        let medicalQuestionaireObj =
          proposalDetails?.isHealthDeclarationSelected?.toLowerCase() ===
          'yes'
            ? getMedicalQuestionsMapped(proposalDetails,member)
            : { relationship: member, questions: [] };
        if (
          medicalQuestionaireObj &&
          medicalQuestionaireObj?.questions &&
          medicalQuestionaireObj?.questions?.length > 0
        ) {
          medicalQuestionaireObj = {
            relationship: member,
            questions: medicalQuestionaireObj?.questions?.map(
              (question) => {
                return {
                  srNo: question?.srNo,
                  answer: question?.answer?.answerText,
                };
              },
            ),
          };
          medicalQuestionaireObj = {
            ...medicalQuestionaireObj,
            questions:
              medicalQuestionaireObj?.questions
                ?.find((q) => q?.srNo?.toLowerCase() === 'master')
                ?.answer?.toLowerCase() !== 'ye'
                ? medicalQuestionaireObj?.questions?.filter(
                    (q) => q?.srNo?.toLowerCase() !== '',
                  )
                : [],
          };
        }
        insuredDetailsObj.medicalQuestionaire = medicalQuestionaireObj
          ? medicalQuestionaireObj
          : { relationship: member, questions: [] };
        insuredDetailsObj.addOnCovers = [];

        let addOnCovers = covers ? covers : values?.covers;
        if (
          val !== undefined &&
          packIdx !== undefined &&
          addOnCoverIdx !== undefined
        ) {
          addOnCovers = {
            ...addOnCovers,
            packs: [
              ...addOnCovers?.packs?.slice(0, packIdx),
              {
                ...addOnCovers?.packs[packIdx],
                addOnCovers: [
                  ...addOnCovers?.packs[packIdx]?.addOnCovers.slice(
                    0,
                    addOnCoverIdx,
                  ),
                  {
                    ...addOnCovers?.packs[packIdx]?.addOnCovers[
                      addOnCoverIdx
                    ],
                    selected: val,
                  },
                  ...addOnCovers?.packs[packIdx]?.addOnCovers.slice(
                    addOnCoverIdx + 1,
                  ),
                ],
              },
              ...addOnCovers?.packs?.slice(packIdx + 1),
            ],
          };
        }
        insuredDetailsObj.addOnCovers = addOnCovers?.packs
          ?.filter((pack) => pack?.index?.includes(member))
          ?.flatMap((pack) =>
            pack.addOnCovers.filter(
              (addOnCover) => addOnCover.selected,
            ),
          );
        if (!insuredDetailsObj.addOnCovers) {
          insuredDetailsObj.addOnCovers = [];
        }

        insuredDetailsObj.prevInsuranceInput = {
          prevInsurerName: proposalDetails?.prevInsuranceDetails[
            member
          ]?.isSoftAdded
            ? ''
            : proposalDetails?.prevInsuranceDetails[member]
                ?.prevInsurerName,
          prevPolicyNo: proposalDetails?.prevInsuranceDetails[member]
            ?.isSoftAdded
            ? ''
            : proposalDetails?.prevInsuranceDetails[member]
                ?.prevPolicyNo,
          prevPolicySI: proposalDetails?.prevInsuranceDetails[member]
            ?.isSoftAdded
            ? ''
            : proposalDetails?.prevInsuranceDetails[member]
                ?.prevPolicySI,
          prevClaimLodged: proposalDetails?.prevInsuranceDetails[
            member
          ]?.isSoftAdded
            ? false
            : proposalDetails?.prevInsuranceDetails[
                member
              ]?.prevClaimLodged?.toLowerCase() === 'yes'
            ? true
            : false,
          claimAmount: proposalDetails?.prevInsuranceDetails[member]
            ?.isSoftAdded
            ? ''
            : proposalDetails?.prevInsuranceDetails[member]
                ?.claimAmount,
          prevPolicyStartDate: proposalDetails?.prevInsuranceDetails[
            member
          ]?.isSoftAdded
            ? ''
            : proposalDetails?.prevInsuranceDetails[member]
                ?.prevPolicyStartDate,
          prevPolicyEndDate: proposalDetails?.prevInsuranceDetails[
            member
          ]?.isSoftAdded
            ? ''
            : proposalDetails?.prevInsuranceDetails[member]
                ?.prevPolicyEndDate,
          cbAmount: proposalDetails?.prevInsuranceDetails[member]
            ?.isSoftAdded
            ? ''
            : proposalDetails?.prevInsuranceDetails[member]?.cbAmount,
        };

        insuredDetailsObj.isPortabilityRequired =
          proposalDetails?.insuredDetails[
            member
          ]?.isPortabilityRequired;
        insuredDetailsObj.cbBonusPct = proposalDetails
          ?.insuredDetails[member]?.cbBonusPct
          ? parseFloat(
          proposalDetails?.insuredDetails[member]?.cbBonusPct,
            )
          : 0;
        insuredDetailsObj.memberID =
          proposalDetails?.insuredDetails[member]?.memberID;
        insuredDetailsObj.memberStatus =
          proposalDetails?.insuredDetails[member]?.memberStatus;

        insuredDetailsArr?.push(insuredDetailsObj);
      });
    return insuredDetailsArr;
  };
  const calculatePremiumForProposalQueryVariables = ({
    val,
    packIdx,
    addOnCoverIdx,
    covers,
    planNameVal,
  }) => {
    const { crn, isNewCustomer, ...restProposerMetaData } =
      viewRenewPolicy?.proposerDetailsMeta;
      viewRenewPolicy?.Please_provide_existing_policy_number;
    return {
      
      input: {
        proposerDetails: {
          ...restProposerMetaData,
          ...proposalDetails?.proposerDetails,
          isThinCustomer: false,
        },
        insuredDetails: getInsuredDetailsObj(
          val,
          packIdx,
          addOnCoverIdx,
          covers,
        ),
        plan: {
          name: planNameVal ? planNameVal: values?.planName,
          code: plans?.find(
            (p) =>
              p?.name?.toLowerCase() ===
              (planNameVal
                ? planNameVal?.toLowerCase()
                : values?.planName?.toLowerCase()),
          )?.code,
        },
        intermediary: {
          intermediaryCode: proposalDetails?.intermediaryData
            ?.intermediary
            ? `${proposalDetails?.intermediaryData?.intermediary}`
            : '',
          locationCode: proposalDetails?.intermediaryData
            ?.businessLocation
            ? `${proposalDetails?.intermediaryData?.businessLocation}`
            : '',
          // fieldUserCode: proposalDetails?.intermediaryData?.fieldUser
          //   ? `${proposalDetails?.intermediaryData?.fieldUser}`
          //   : '',
          fieldUserCode: proposalDetails?.intermediaryData?.fieldUser
          ? proposalDetails?.intermediaryData?.fieldUserList?.find(
            (d ) =>  d.fieldUserName === proposalDetails?.intermediaryData?.fieldUser 
          )?.fieldUserCode
            : '',
        },
        zone: '',
        quotationType: viewRenewPolicy?.businessType,
        sumInsured: parseFloat(values?.sumInsured),
        deductSumInsured: parseFloat(values?.deductSumInsured),
        startDate: date,
        startTime: '00:00',
        tenure: values?.tenure,
        coverType: values?.coverType,
        isHealthDeclarationSelected:
          proposalDetails?.isHealthDeclarationSelected?.toLowerCase() ===
          'yes',
        productCode,
        isExistingEmployee:
          proposalDetails?.proposerDetails?.employeeNumber !== ''
            ? true
            : false,
        quoteNumber: viewRenewPolicy?.quoteNumber,
        employeeNumber:
          proposalDetails?.proposerDetails?.employeeNumber,
        existingPolicyNumber: (viewRenewPolicy?.Please_provide_existing_policy_number!='' || viewRenewPolicy?.Please_provide_existing_policy_number!=undefined)?viewRenewPolicy?.Please_provide_existing_policy_number:'' ,//viewRenewPolicy?.policyNumber,//SAEARN024
        proposerPincode:
          proposalDetails?.proposerDetails?.commPincode,
        renewalMandateDetails: {
          renewalPaymentMandate:
            viewRenewPolicy?.renewalMandateDetails?.renewalPaymentMandate?.toLowerCase() ===
            'yes'
              ? true
              : false,
          renewalPaymentMandateTakenInNameOf:
            viewRenewPolicy?.renewalMandateDetails
              ?.renewalPaymentMandateTakenInNameOf,
          termForMandateOpted:
            viewRenewPolicy?.renewalMandateDetails
              ?.termForMandateOpted,
          typeOfDebit:
            viewRenewPolicy?.renewalMandateDetails?.typeOfDebit,
          accountNumber:
            viewRenewPolicy?.renewalMandateDetails?.accountNumber,
          destinationBankName:
            viewRenewPolicy?.renewalMandateDetails
              ?.destinationBankName,
          destinationIfscCode:
            viewRenewPolicy?.renewalMandateDetails
              ?.destinationIfscCode,
          destinationMicrCode:
            viewRenewPolicy?.renewalMandateDetails
              ?.destinationMicrCode,
          destinationBranchName:
            viewRenewPolicy?.renewalMandateDetails?.branchName,
          mandateAmount: parseFloat(
            viewRenewPolicy?.renewalMandateDetails?.mandateAmount,
          ),
          finalCollectionDate:
            viewRenewPolicy?.renewalMandateDetails
              ?.finalCollectionDate,
          destinationBankAccountType:
            viewRenewPolicy?.renewalMandateDetails
              ?.destinationBankAccountType,
        },
      },
    };
  };

  const [
    getPlanDetails,
    { loading: loadingPlanDetails, error: errorPlanDetails },
 
  ] = useLazyQuery(GET_PLAN_COVER_DETAILS, {
    fetchPolicy: 'network-only',
    onCompleted: async (data) => {
      // console.log("dataaaaaoncomplete",data)
      try {
        if (
          !data?.planAndCovers?.find(
            (plan) =>
              plan?.name?.toString()?.toLowerCase() ===
              values?.planName?.toString()?.toLowerCase(),
          )
        ) {
          setFieldValue('planName', '');
          setFieldValue('planCode', '');
          setFieldValue('totalPremium', '');
        } else {
          setErrorPremium(null);
          setWarningPremium(null);
          try {
            const calculatePremiumForProposalQuery = fetchQuery({
              query: CALCULATE_PREMIUM_FOR_PROPOSAL,
              fetchPolicy: 'network-only',
              variables: calculatePremiumForProposalQueryVariables({
                planNameVal: values?.planName,
                covers: data?.planAndCovers?.plans?.find(
                  (p) =>
                    p?.name?.toLowerCase() ===
                    values?.planName?.toLowerCase(),
                ),
              }),
            });
            setCalculatingPremium(true);
            const { data: calculatePremiumData } =
              await calculatePremiumForProposalQuery;
            setCalculatingPremium(false);
            // const { warningMsg, ...restPremiumData } =
              calculatePremiumData?.calculatePremiumForProposalST;
            setFieldValue(
              `totalPremium`,
              calculatePremiumData?.calculatePremiumForProposalST
                ?.totalPremium,
            );
            // setFieldValue(`premium`, restPremiumData);
            if (
              calculatePremiumData?.calculatePremiumForProposalST
                ?.warningMsg
            ) {
              setWarningPremium(
                calculatePremiumData?.calculatePremiumForProposalST
                  ?.warningMsg,
              );
            }
          } catch (error) {
            setCalculatingPremium(false);
                  //Unexpected Token - Health Renewal
                  if(error?.message?.includes("Unexpected token")){
                    setResultPremiumError('Please try again after sometime');
                  }
                  //Unexpected Token - Health Renewal
            setErrorPremium(error?.message);
            setFieldValue(`totalPremium`, '');
            setFieldValue(`premium`, null);
            setWarningPremium(null);
          }
        }
        setPlans(data?.planAndCovers);
        setInitLoad(true);
      } catch (error) {
        setCalculatingPremium(false);
          //Unexpected Token - Health Renewal
          if(error?.message?.includes("Unexpected token")){
            setResultPremiumError('Please try again after sometime');
          }
          //Unexpected Token - Health Renewal
        setErrorPremium(error.message);
        setFieldValue(`totalPremium`, '');
        setFieldValue(`premium`, null);
      }
    },
  });
 
  useEffect(() => {
    if (showCoversPlans) {
      if (initialValues?.planName && !initialValues?.totalPremium) {
        setFieldValue(`covers`, {
          baseCovers:
            plans?.length > 0
              ? plans?.find(
                  (p) =>
                    p?.name?.toLowerCase() ===
                    initialValues?.planName?.toLowerCase(),
                )?.covers
              : [],
          packs:
            !initialValues?.planName || initLoad
              ? plans?.find(
                  (p) =>
                    p?.name?.toLowerCase() ===
                    initialValues?.planName?.toLowerCase(),
                )?.packs
              : planData?.plans?.length > 0
              ? planData?.plans?.find(
                  (p) =>
                    p?.name?.toLowerCase() ===
                    initialValues?.planName?.toLowerCase(),
                )?.packs
              : [],
        });
        setErrorPremium(null);
        setWarningPremium(null);
        setCalculatingPremium(true);
        fetchQuery({
          query: CALCULATE_PREMIUM_FOR_PROPOSAL,
          fetchPolicy: 'network-only',
          variables: calculatePremiumForProposalQueryVariables({
            planNameVal: initialValues?.planName,
            covers: initLoad
              ? plans?.find(
                  (p) =>
                    p?.name?.toLowerCase() ===
                    initialValues?.planName?.toLowerCase(),
                )
              : planData?.plans?.find(
                  (p) =>
                    p?.name?.toLowerCase() ===
                    initialValues?.planName?.toLowerCase(),
                ),
          }),
        })
          ?.then((response) => {
            setCalculatingPremium(false);
            const { data: calculatePremiumData } = response;
            // const { warningMsg, ...restPremiumData } =
              calculatePremiumData?.calculatePremiumForProposalST;
            setFieldValue(
              `totalPremium`,
              calculatePremiumData?.calculatePremiumForProposalST
                ?.totalPremium,
            );
            // setFieldValue(`premium`, restPremiumData);
            if (
              calculatePremiumData?.calculatePremiumForProposalST
                ?.warningMsg
            ) {
              setWarningPremium(
                calculatePremiumData?.calculatePremiumForProposalST
                  ?.warningMsg,
              );
            }
          })
          ?.catch((error) => {
            setCalculatingPremium(false);
            //Unexpected Token - Health Renewal
            if(error?.message?.includes("Unexpected token")){
              setResultPremiumError('Please try again after sometime');
            }
            //Unexpected Token - Health Renewal
            setErrorPremium(error?.message);
            setFieldValue(`totalPremium`, '');
            setFieldValue(`premium`, null);
            setWarningPremium(null);
          });
      }
    }
  }, [showCoversPlans]);
  useEffect(() => {
    // console.log("insiseuseeffect")
    if (date && productCode) {
      // console.log("insideif")
      getProductDetails({
       
        variables: {
          input: {
          productCode,
          startDate: date,
          },
        },
      });
      if (
        proposalDetails?.insuredDetails &&
        values?.sumInsured &&
        !isCancelled &&
        (!initialValues?.planName ||
          !initialValues?.totalPremium ||
          initLoad)
      ) {
        let memArr = [];
        Object.keys(proposalDetails?.insuredDetails)
          .filter(
            (mem) =>
              !proposalDetails?.insuredDetails[mem]
                ?.isMemberDeleted &&
              !proposalDetails?.insuredDetails[mem]?.isSoftAdded &&
              !proposalDetails?.insuredDetails[mem]?.isHardDeleted,
          )
          .forEach((mem) => {
            memArr.push({
              relationship: mem?.toString(),
              gender:
                proposalDetails?.insuredDetails[
                  mem
                ]?.gender?.toString(),
              dob: proposalDetails?.insuredDetails[
                mem
              ]?.dob?.toString(),
              age: proposalDetails?.insuredDetails[
                mem
              ]?.age?.toString(),
            });
          });
      
        getPlanDetails({
          variables: {
            input: {
              productCode,
            sumInsured: values?.sumInsured,
            deductSumInsured: parseInt( values?.deductSumInsured),
            startDate: date,
            members: memArr,
            imdCode:
                forwardedRenewFormRef?.current?.values
                  ?.intermediaryData?.intermediary ||
              viewRenewPolicy?.intermediaryDetails?.code,
            },
          },
        });

        // console.log("getPlanDetails",getPlanDetails);
      }
    }
  }, [
    proposalDetails?.insuredDetails,
    proposalDetails?.insuredDetails
      ? Object.keys(proposalDetails?.insuredDetails)?.length
      : null,
    date,
    productCode,
    values?.sumInsured,
    values?.deductSumInsured,
    values?.coverType,
    valuesBeforeEdit,
    isCancelled,
  ]);

  const other_props = {
    flow: 'cols',
    textType: 'normal',
    repeat: repeatFormsonEdit,
    gapX: 20,
    gapY: 0,
    spaceY: 2,
    size: 'full',
    titleSeverity: 'info',
    useExpandablePaper: false,
    useGlobalExpandablePaper: false,
    nullData: () => <Text severity="neutral">Not Captured</Text>,
  };
  //  console.log("1*SI*",dataProductDetails?.productDetails?.customApplicableSumInsureds);

  const planDetailsData = [
    {
      title: (
        <Text type="large" severity="info">
          Choose Cover
        </Text>
      ),
      grid_type: 'input',
      grid_data: [
        {
          type: 'select',
          label: (
            <Text severity="info" type="label">
              Cover Type <Text severity="error">*</Text>
            </Text>
          ),
          name: 'coverType',
          size: 'large',
          disabled:
            isCalculatingPremium ||
            loadingPlanDetails ||
            viewRenewPolicy?.isProposalRenewed,
          onDataChange: (val, _) => {
            // setFieldValue('planName', '');
            // setFieldValue('planCode', '');
            // setFieldValue('totalPremium', '');
            setErrorPremium(null);
            setCalculatingPremium(false);
            setWarningPremium(null);
          },
          data:
            dataProductDetails &&
            dataProductDetails?.productDetails &&
            dataProductDetails?.productDetails
              ?.applicableCoverTypes &&
            dataProductDetails?.productDetails?.applicableCoverTypes
              ?.length > 0
              ? dataProductDetails?.productDetails?.applicableCoverTypes?.map(
                  (coverType) => {
                    return {
                      label: coverType?.value
                        ? coverType?.value?.toString()
                        : '',
                      value: coverType?.code
                        ? coverType?.code?.toString()
                        : '',
                    };
                  },
                )
              : [],
        },
        {
          type: 'select',
          label: (
            <Text severity="info" type="label">
               Deductible Sum Insured <Text severity="error">*</Text>
            </Text>
          ),
          name: 'deductSumInsured',
          size: 'large',
          iconPre: (
            <Text
              severity={
                isCalculatingPremium ||
                loadingPlanDetails ||
                viewRenewPolicy?.isProposalRenewed
                  ? 'neutral'
                  : 'info'
              }
              className={
                isCalculatingPremium ||
                loadingPlanDetails ||
                viewRenewPolicy?.isProposalRenewed
                  ? 'font-bold'
                  : ''
              }
            >
              {branding.currency}
            </Text>
          ),
          disabled:
            isCalculatingPremium ||
            loadingPlanDetails ||
            viewRenewPolicy?.isProposalRenewed,
          className: `${
            isCalculatingPremium ||
            loadingPlanDetails ||
            viewRenewPolicy?.isProposalRenewed
              ? 'border-neutral-dark'
              : ''
          }`,
          onDataChange: (val, _) => {
              setFieldValue('sumInsured',dataProductDetails?.productDetails?.customApplicableSumInsureds.find((sumInsured) => 
              sumInsured.deductSumInsured.toString() 
              === val,
              ).sumInsured[0].toString())
             setErrorPremium(null);
            setCalculatingPremium(false);
            setWarningPremium(null);
            setCancelled(false);
            if (!initLoad) {
              setInitLoad(true);
            }
            
          },
          data:
            dataProductDetails &&
            dataProductDetails?.productDetails &&
            dataProductDetails?.productDetails
              ?.customApplicableSumInsureds &&
            dataProductDetails?.productDetails?.customApplicableSumInsureds
              ?.length > 0
              ? dataProductDetails?.productDetails?.customApplicableSumInsureds?.map((sumInsured) => {
                // console.log(dataProductDetails?.productDetails?.customApplicableSumInsureds);
                return {
                  label: `${CurrencyFormater(
                    sumInsured.deductSumInsured,
                    false,
                    true,
                    branding,
                    false,
                  )}`,
                  value: sumInsured.deductSumInsured
                    ? sumInsured.deductSumInsured.toString()
                    : '',
                };
              })
              : [],
        },
        {
          type: 'select',
          label: (
            <Text severity="info" type="label">
              Sum Insured <Text severity="error">*</Text>
            </Text>
          ),
          name: 'sumInsured',
          size: 'large',
       
          iconPre: (
            <Text
              severity={
                isCalculatingPremium ||
                loadingPlanDetails ||
                viewRenewPolicy?.isProposalRenewed
                  ? 'neutral'
                  : 'info'
              }
              className={
                isCalculatingPremium ||
                loadingPlanDetails ||
                viewRenewPolicy?.isProposalRenewed
                  ? 'font-bold'
                  : ''
              }
            >
              {branding.currency}
            </Text>
          ),
          disabled:
            isCalculatingPremium ||
            loadingPlanDetails ||
            viewRenewPolicy?.isProposalRenewed,
          className: `${
            isCalculatingPremium ||
            loadingPlanDetails ||
            viewRenewPolicy?.isProposalRenewed
              ? 'border-neutral-dark'
              : ''
          }`,
          onDataChange: (val, _) => {
            setFieldValue('planName', '');
            setFieldValue('planCode', '');
            setFieldValue('totalPremium', '');
            // setFieldValue('cover.sum_insured',[]);
            setErrorPremium(null);
            setCalculatingPremium(false);
            setCancelled(false);
            if (!initLoad) {
              
              setInitLoad(true);
            }
            
          },
        data:  dataProductDetails?.productDetails !== undefined && values.sumInsured !== ''
            ? dataProductDetails?.productDetails?.customApplicableSumInsureds
            .find(
              (sumInsured) =>
              sumInsured.deductSumInsured.toString() ==
                values.deductSumInsured.toString(),
            ).sumInsured
            .filter((x, i, a) => a.indexOf(x) == i)
            .map((el)=>{
              return {
                    label:`${CurrencyFormater(
                                  el,
                                  false,
                                  true,
                                  branding,
                                  false,
                                )}`,
                    value: el ? el.toString():'',
              };
            }) 
           : []
        },
            
       

        {
          type: 'render',
          component: () => {
            return (
              <Label text="Tenure" severity="info">
                <Text type="normal">
                  {forwardedRef?.current?.values?.tenure}
                </Text>
              </Label>
            );
          },
        },
      ],
    },
    {
      title: <Text type="large">Choose Plan</Text>,
      grid_type: 'input',
      grid_data: [
        loadingPlanDetails || errorPlanDetails
          ? {
              type: 'render',
              colSpan: repeatFormsReadOnly,
              component: () => {
                return (
                  <>
                    {loadingPlanDetails && (
                      <Loading
                        customMessage={'Fetching Plan Details'}
                      />
                    )}
                    {!loadingPlanDetails && errorPlanDetails && (
                      <Error error={errorPlanDetails} />
                    )}
                  </>
                );
              },
            }
          : !loadingPlanDetails && !errorPlanDetails
          ? {
              type: 'select',
              label: (
                <Text severity="info" type="label">
                  Plan Name <Text severity="error">*</Text>
                </Text>
              ),
              name: 'planName',
              size: 'large',
              disabled:
                isCalculatingPremium ||
                loadingPlanDetails ||
                viewRenewPolicy?.isProposalRenewed,
              data: plans?.map((p) => {
                return {
                  label: p?.name?.toString(),
                  value: p?.name?.toString(),
                };
              }),
              onDataChange: async (val, _) => {
                setFieldValue(`covers`, {
                  baseCovers:
                    plans?.length > 0
                      ? plans?.find(
                          (p) =>
                            p?.name?.toLowerCase() ===
                            val?.toLowerCase(),
                        )?.covers
                      : [],
                  packs:
                    !initialValues?.planName || initLoad
                      ? plans?.find(
                          (p) =>
                            p?.name?.toLowerCase() ===
                            val?.toLowerCase(),
                        )?.packs
                      : planData?.plans?.length > 0
                      ? planData?.plans?.find(
                          (p) =>
                            p?.name?.toLowerCase() ===
                            val?.toLowerCase(),
                        )?.packs
                      : [],
                });
                setErrorPremium(null);
                setWarningPremium(null);
                try {
                  const calculatePremiumForProposalQuery = fetchQuery(
                    {
                      query: CALCULATE_PREMIUM_FOR_PROPOSAL,
                      fetchPolicy: 'network-only',
                      variables:
                        calculatePremiumForProposalQueryVariables({
                          planNameVal: val,
                          covers: initLoad
                            ? plans?.find(
                                (p) =>
                                  p?.name?.toLowerCase() ===
                                  val?.toLowerCase(),
                              )
                            : planData?.plans?.find(
                                (p) =>
                                  p?.name?.toLowerCase() ===
                                  val?.toLowerCase(),
                              ),
                        }),
                    },
                  );
                  setCalculatingPremium(true);
                  const { data: calculatePremiumData } =
                    await calculatePremiumForProposalQuery;
                  setCalculatingPremium(false);
                  setFieldValue(
                    `totalPremium`,
                    calculatePremiumData?.calculatePremiumForProposalST
                      ?.totalPremium,
                  );
                  // setFieldValue(`premium`, restPremiumData);
                  if (
                    calculatePremiumData?.calculatePremiumForProposalST
                      ?.warningMsg
                  ) {
                    setWarningPremium(
                      calculatePremiumData
                        ?.calculatePremiumForProposalST?.warningMsg,
                  );
                  }
                } catch (error) {
                  setCalculatingPremium(false);
                    //Unexpected Token - Health Renewal
            if(error?.message?.includes("Unexpected token")){
              setResultPremiumError('Please try again after sometime');
            }
            //Unexpected Token - Health Renewal
                  setErrorPremium(error?.message);
                  setFieldValue(`totalPremium`, '');
                  setFieldValue(`premium`, null);
                  setWarningPremium(null);
                }
              },
            }
          : null,
        !loadingPlanDetails && !errorPlanDetails
          ? {
              type: 'render',
              component: () => {
                return (
                  <div className="flex flex-col justify-start mt-2">
                    <Text type="label" severity="info">
                      Annual Premium (inclusive of taxes)
                    </Text>
                    <Text
                      type={
                        (isCalculatingPremium || errorPremium) &&
                        !values?.totalPremium
                          ? 'normal'
                          : values?.totalPremium
                          ? 'larger'
                          : 'normal'
                      }
                      severity={
                        (isCalculatingPremium || errorPremium) &&
                        !values?.totalPremium
                          ? 'info'
                          : values?.totalPremium
                          ? 'info'
                          : 'neutral'
                      }
                    >
                      {isCalculatingPremium && !errorPremium ? (
                        <Text
                          type="normal"
                          severity="info"
                          className="flex space-x-2 items-center"
                        >
                          <span>
                            <FontAwesomeIcon
                              icon={faSpinner}
                              spin={true}
                            />
                          </span>
                          <span>Calculating Premium</span>
                        </Text>
                      ) : values?.totalPremium ? (
                        <CountAnimation
                          end={values?.totalPremium}
                          duration={1}
                          decimals={2}
                          prefix={branding.currency + ' '}
                          formattingFn = {(num) => {
                            return CurrencyFormater(
                              num,
                              true,
                              false,
                              branding,
                              true,
                            );
                          }}
                        />
                      ) : errorPremium ? (
                        screen === 'mobile' ? null : (
                          <Text
                            type="normal"
                            severity="error"
                            className="flex space-x-2 items-center"
                          >
                            <span>
                              <FontAwesomeIcon icon={faInfoCircle} />
                            </span>
                            <span>Error Calculating Premium</span>
                          </Text>
                        )
                      ) : (
                        'Not Captured'
                      )}
                    </Text>
                  </div>
                );
              },
            }
          : null,
        errorPremium && !values?.totalPremium
          ? {
              type: 'render',
              colSpan: repeatFormsonEdit,
              component: () => {
                return (
                  <Text
                    severity="error"
                    type="label"
                    className="flex space-x-2 -mt-2"
                  >
                    <Text>
                      <FontAwesomeIcon icon={faInfoCircle} />
                    </Text>
                    <Text>{errorPremium}</Text>
                  </Text>
                );
              },
            }
          : null,
        !errorPremium && warningPremium
          ? {
              type: 'render',
              colSpan: repeatFormsonEdit,
              component: () => {
                return (
                  <Text
                    severity="warning"
                    type="label"
                    className="flex space-x-2 -mt-2"
                  >
                    <Text>
                      <FontAwesomeIcon icon={faExclamationTriangle} />
                    </Text>
                    <Text>{warningPremium}</Text>
                  </Text>
                );
              },
            }
          : null,
      ].filter((d) => d),
    },
    // {
    //   title: (
    //     <Text type="large" severity="info">
    //       Basic Covers
    //     </Text>
    //   ),
    //   grid_type: 'input',
    //   grid_data: [
    //     {
    //       type: 'render',
    //       colSpan: repeatFormsReadOnly,
    //       component: () => {
    //         return (
    //           <div className="flex flex-col justify-start">
    //             <Grid  repeat= {repeatFormsReadOnly}  gap={2}>
    //               {values?.covers?.baseCovers?.map((cover, idx) => {
    //                 return (
    //                   <>
    //                     <GridItem key={idx}>
    //                       <div className="flex flex-row space-x-1 items-center">
    //                         <div className="text-success">
    //                           <FontAwesomeIcon icon={faCheck} />
    //                         </div>
    //                         <Text type="label">{cover.name}</Text>
    //                       </div>
    //                     </GridItem>
    //                   </>
    //                 );
    //               })}
    //             </Grid>
    //           </div>
    //         );
    //       }
    //     },
    //   ]
    // },
    {
      title: (
        <Text type="large" severity="info">
          Choose Add On Covers
        </Text>
      ),
      grid_type: 'input',
      grid_data: [
        {
          type: 'render',
          colSpan: repeatFormsonEdit,
          component: () => {
            return (
              <>
                {(!plans?.find(
                  (plan) =>
                    plan?.name?.toLowerCase() ===
                    values?.planName?.toLowerCase(),
                ) ||
                  values?.covers?.packs?.filter(
                    (pack) => pack?.addOnCovers,
                  )?.length === 0) && (
                  <div className="flex flex-col justify-start mt-3 text-neutral-dark text-2xl text-center">
                    No Add On Covers Available or Selected.
                  </div>
                )}
              </>
            );
          },
        },
        loadingPlanDetails || errorPlanDetails || !values?.planName
          ? null
          : {
              type: 'render',
              colSpan: repeatFormsReadOnly,
              component: () => {
                return (
                  <div className="flex flex-col justify-start">
                    {values?.covers?.packs
                      ?.filter((pack) => pack?.addOnCovers)
                      ?.map((pack, packIdx) => {
                        return (
                          <div key={packIdx} className="space-y-2">
                            <Text
                              type="normal"
                              severity={
                                viewRenewPolicy?.isProposalRenewed
                                  ? 'neutral-darker'
                                  : 'info'
                              }
                              className="mb-1 flex items-center space-x-2"
                            >
                              <Text className={'my-2'}>
                                {pack?.name}
                              </Text>
                              {pack?.addOnCovers?.filter(
                                (addOnCover) => addOnCover?.selected,
                              )?.length > 0 ? (
                                <Text type="label" className="mt-0.5">
                                  {' '}
                                  ({' '}
                                  {
                                    pack?.addOnCovers?.filter(
                                      (addOnCover) =>
                                        addOnCover?.selected,
                                    )?.length
                                  }{' '}
                                  Selected )
                                </Text>
                              ) : (
                                ''
                              )}
                            </Text>
                            <Grid
                              {...{
                                flow: 'cols',
                                repeat: repeatFormsReadOnly,
                                gapY: 0,
                              }}
                            >
                              {pack &&
                                pack?.addOnCovers?.length > 0 &&
                                pack?.addOnCovers?.map(
                                  (add, addOnCoverIdx) => {
                                    return (
                                      <GridItem
                                        key={addOnCoverIdx}
                                        colSpan={1}
                                        className="flex flex-col justify-center -my-2"
                                      >
                                        <QuantaToggle
                                          className={
                                            'flex flex-col justify-center'
                                          }
                                          name={`covers.packs[${packIdx}].addOnCovers[${addOnCoverIdx}].selected`}
                                          label={add?.name}
                                          checked={add?.selected}
                                          labelType={'label'}
                                          disabled={
                                            viewRenewPolicy?.isProposalRenewed
                                          }
                                          onChange={async (val) => {
                                            try {
                                              setFieldValue(
                                                `covers.packs[${packIdx}].addOnCovers[${addOnCoverIdx}].selected`,
                                                val,
                                              );
                                              setFieldValue(
                                                `totalPremium`,
                                                '',
                                              );
                                              setFieldValue(
                                                `premium`,
                                                null,
                                              );
                                              setErrorPremium(null);
                                              setWarningPremium(null);
                                              const calculatePremiumForProposalQuery =
                                                fetchQuery({
                                                  query:
                                                    CALCULATE_PREMIUM_FOR_PROPOSAL,
                                                  fetchPolicy:
                                                    'network-only',
                                                  variables:
                                                    calculatePremiumForProposalQueryVariables(
                                                      {
                                                        val,
                                                        packIdx,
                                                        addOnCoverIdx,
                                                      },
                                                    ),
                                                });
                                              setCalculatingPremium(
                                                true,
                                              );
                                              const {
                                                data: calculatePremiumData,
                                              } = await calculatePremiumForProposalQuery;
                                              const {
                                                warningMsg,
                                                ...restPremiumData
                                              } =
                                                calculatePremiumData?.calculatePremiumForProposalST;
                                              setCalculatingPremium(
                                                false,
                                              );
                                              setFieldValue(
                                                `totalPremium`,
                                                calculatePremiumData
                                                  ?.calculatePremiumForProposalST
                                                  ?.totalPremium,
                                              );
                                              setFieldValue(
                                                `premium`,
                                                restPremiumData,
                                              );
                                              if (
                                                calculatePremiumData
                                                  ?.calculatePremiumForProposalST
                                                  ?.warningMsg
                                              ) {
                                                setWarningPremium(
                                                  calculatePremiumData
                                                    ?.calculatePremiumForProposalST
                                                    ?.warningMsg,
                                              );
                                              }
                                            } catch (error) {
                                              setCalculatingPremium(
                                                false,
                                              );
                                              setErrorPremium(
                                                error.message,
                                              );
                                              setWarningPremium(null);
                                            }
                                          }}
                                        />
                                      </GridItem>
                                    );
                                  },
                                )}
                            </Grid>
                          </div>
                        );
                      })}
                  </div>
                );
              },
            },
      ].filter((d) => d),
    },
  ].filter((d) => d);
  return (
    <div className="text-black font-normal">
      <Modal
        display={showCoversPlans}
        size={screen === 'desktop' ? 'large' : 'full'}
        title={`Your Plan & Cover Details`}
        className="h-screen flex flex-col justify-start"
        onClose={(e) => {
          setValues(valuesBeforeEdit);
          setShowCoversPlans(false);
          setErrorPremium(null);
          setWarningPremium(null);
          if (!isCancelled) {
            setCancelled(true);
          }
          setPlans(planData?.plans ? planData?.plans : []);
        }}
        modalCloseDisabled={
          isCalculatingPremium || loadingPlanDetails
        }
        severity={'action'}
      >
        <div className="h-full flex flex-col justify-between">
          {loadingProductDetails && (
            <Loading customMessage="Fetching Product Details" />
          )}
          {errorProductDetails && (
            <Error error={errorProductDetails} />
          )}
          {!loadingProductDetails && !errorProductDetails && (
            <>
              <MixedGridGroup
                {...{
                  data: planDetailsData,
                  ...other_props,
                }}
              />
              <div className="flex justify-end items-baseline w-full space-x-2 pb-2">
                <span>
                  <Button
                    type={'button'}
                    size={'small'}
                    disabled={
                      viewRenewPolicy?.isProposalRenewed ||
                      loadingPlanDetails ||
                      loadingProductDetails ||
                      (errorPlanDetails !== null &&
                        errorPlanDetails !== undefined) ||
                      (errorProductDetails !== null &&
                        errorProductDetails !== undefined) ||
                      Object.keys(errors).length > 0 ||
                      values?.planName === '' ||
                      (errorPremium !== null &&
                        values?.totalPremium === '') ||
                      isCalculatingPremium
                    }
                    iconPre={
                      <FontAwesomeIcon
                        icon={faSave}
                        className={'ml-2'}
                      />
                    }
                    className="w-24"
                    onClick={(_) => {
                      setShowCoversPlans(false);
                      updateViewRenewPolicy({
                        planData: {
                          plans: [
                            ...plans?.filter(
                              (p) =>
                                p?.name?.toLowerCase() !==
                                values?.planName?.toLowerCase(),
                            ),
                            {
                              ...plans?.find(
                                (p) =>
                                  p?.name?.toLowerCase() ===
                                  values?.planName?.toLowerCase(),
                              ),
                              packs: values?.covers?.packs,
                              premium: values?.premium,
                            },
                          ],
                        },
                        prevPlanData: {
                          plans: [
                            ...plans?.filter(
                              (p) =>
                                p?.name?.toLowerCase() !==
                                values?.planName?.toLowerCase(),
                            ),
                            {
                              ...plans?.find(
                                (p) =>
                                  p?.name?.toLowerCase() ===
                                  values?.planName?.toLowerCase(),
                              ),
                              packs: values?.covers?.packs,
                              premium: values?.premium,
                            },
                          ],
                        },
                        prevPlanName: values?.planName,
                        prevTotalPremium: values?.totalPremium,
                        quoteData: {
                          ...quoteData,
                          cover: {
                            ...quoteData?.cover,
                            type: values?.coverType,
                            sum_insured: values?.sumInsured,
                          },
                        },
                        planName: values?.planName,
                        planCode: plans?.find(
                          (plan) =>
                            plan?.name?.toLowerCase() ===
                            values?.planName?.toLowerCase(),
                        )?.code,
                        totalPremium: values?.totalPremium,
                      });
                      forwardedAlertsRef.current = [
                        {
                          id: Date.now(),
                          content: (
                            <div>
                              Plan and Add on covers updated
                              successfully
                            </div>
                          ),
                          timeout: 7000,
                          disableClose: false,
                          type: 'info',
                        },
                      ];
                      forwardedRenewFormRef?.current?.setFieldValue(
                        'allowCalcPremium',
                        false,
                      );
                      document.body.classList.remove(
                        'overflow-y-hidden',
                      );
                    }}
                  >
                    Save
                  </Button>
                </span>
                <span>
                  <Button
                    flat={true}
                    type={'button'}
                    size={'small'}
                    iconPre={
                      <FontAwesomeIcon
                        icon={faTimesCircle}
                        className={'ml-2'}
                      />
                    }
                    className="w-24"
                    disabled={
                      isCalculatingPremium || loadingPlanDetails
                    }
                    onClick={(_) => {
                      setValues(valuesBeforeEdit);
                      setShowCoversPlans(false);
                      setErrorPremium(null);
                      setWarningPremium(null);
                      if (!isCancelled) {
                        setCancelled(true);
                      }
                      setPlans(
                        planData?.plans ? planData?.plans : [],
                      );
                      document.body.classList.remove(
                        'overflow-y-hidden',
                      );
                    }}
                  >
                    Cancel
                  </Button>
                </span>
              </div>
            </>
          )}
        </div>
      </Modal>
    </div>
  );
}
